/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */
import type { ReactNode } from 'react';

import { cssMap, jsx } from '@atlaskit/css';
import { Pressable } from '@atlaskit/primitives/compiled/pressable';
import { token } from '@atlaskit/tokens';

type Props = {
	children: ReactNode;
	onClick: () => void;
};

const styles = cssMap({
	button: {
		backgroundColor: token('color.background.neutral.subtle'),
		color: token('color.link'),
		font: token('font.body'),
		fontWeight: token('font.weight.medium'),
		maxWidth: '150px',
		overflow: 'hidden',
		paddingBlock: token('space.0'),
		paddingInline: token('space.0'),
		'&:hover': {
			textDecoration: 'underline',
		},
	},
});

export const LinkButton = ({ children, onClick }: Props): JSX.Element => {
	return (
		<Pressable onClick={onClick} xcss={styles.button}>
			{children}
		</Pressable>
	);
};
